export const devConfiguration = {
  getLogin: "/admin/signIn",
  forgotPassword: "/admin/forgetPassword",
  verifyOtp: "/admin/verifyOTP",
  resetPassword: "/admin/resetPassword",
  createAdminStripeAccount: "/admin/createAdminStripeAccount",
  adminAccountCreateSuccess: "/admin/admin_account_create_success",
  adminAccountCreateRefresh: "/admin/admin_account_create_refresh",
  getAdminStripeAccountDetail: "/admin/getAdminStripeAccountDetail",
  getCMSoverview: "/admin/getCMS?type=overview",
  getCMSformatview: "/admin/getCMS?type=format_rules",
  updateCMS: "/admin/updateCMS",
  addVenue: "/admin/addVenue",
  getVenuelist: "/admin/viewVenueList",
  getVenueById: "/admin/viewVenue",
  updateVenue: "/admin/updateVenue",
  addNews: "/admin/addNews",
  getNewslist: "/admin/viewNewsList",
  updateNewsState: "/admin/updateNewsStatus",
  updateNews: "/admin/updateNews",
  viewNews: "/admin/viewNews",
  addTeam: "/admin/addTeam",
  deleteNews: "/admin/deleteNews",
  teamList: "/admin/viewTeamList",
  teamBlock: "/admin/updateTeamStatus",
  teamDelete: "/admin/deleteTeam",
  teamView: "/admin/viewTeam",
  updateTeam: "/admin/updateTeam",
  addBanner: "/admin/banners",
  bannerList: "/admin/banners",
  bannerDetails: "/admin/banners",
  updateBanner: "/admin/banners",
  updatestatus: "/admin/banners/status",
  bannerUpdate: "/admin/updateBanner",
  viewBanner: "/admin/viewBanner",
  deleteBanner: "/admin/banners",
  addFeaturedRestaurant: "/admin/addFeaturedRestaurant",
  cuisineList: "/admin/cuisineList",
  cuisineBlock: "/admin/updateCuisineStatus",
  addCuisine: "/admin/addCuisine",
  updateCuisine: "/admin/updateCuisine",
  dishCategoryList: "/admin/dishCategoryList",
  dishCategoryBlock: "/admin/updateDishCategoryStatus",
  dishCategoryDelete: "/admin/deleteDishCategory",
  addDishCategory: "/admin/addDishCategory",
  updateDishCategory: "/admin/updateDishCategory",
  mealTypeList: "/admin/mealTypeList",
  addMealType: "/admin/addMealType",
  updateMealType: "/admin/updateMealType",
  mealTypeStatusUpdate: "/admin/mealTypeStatusUpdate",
  customerList: "/admin/customers",
  customerStatusUpdate: "/admin/updateCustomerStatus",
  customerDetails: "/admin/customers",
  customerOrders: "/admin/customerOrders",
  ingredientList: "/admin/ingridentList",
  ingredientStatusUpdate: "/admin/ingridentStatusUpdate",
  ingredientDelete: "/admin/deleteIngredient",
  addIngredient: "/admin/addIngrident",
  updateIngredient: "/admin/updateIngrident",
  allergiesList: "/admin/allergieList",
  addAllergies: "/admin/addAllergie",
  updateAllergies: "/admin/updateAllergie",
  allergiesStatusUpdate: "/admin/updateAllergyStatus",
  allergiesDelete: "/admin/deleteAllergy",
  restaurantList: "/admin/restaurentList",
  restaurantDetails: "/admin/restaurent",
  restaurantCommissionLog: "/admin/restaurent",
  restaurantCommissionScheduleList: "/admin/restaurent",
  scheduleDiscountedCommission: "/admin/restaurent",
  updateCommissionSchedule: "/admin/restaurent",
  deleteCommissionSchedule: "/admin/restaurent",
  updateCommissionEndDate: "/admin/restaurent",
  restaurantApprovalStatus: "/admin/restaurent",
  restaurantStatus: "/admin/restaurent/status",
  restaurantMenuCatalogue: "/admin/restaurent/menu-catalogue",
  menuCatalogueDetail: "/admin/restaurent/menu-catalogue-detail",
  menuDishAdminReviewList: "/admin/menuDishAdminReviewList",
  menuDishAdminReviewDetail: "/admin/menuDishAdminReviewDetail",
  approveMenuDishAdminReview: "/admin/approveMenuDishAdminReview",
  cms: "/admin/cms",
  faq: "/admin/faq",
  addFaq: "/admin/addFaq",
  updateFaq: "/admin/updateFaq",
  deleteFaq: "/admin/deleteFaq",
  addCms: "/admin/addCms",
  updateCms: "/admin/cms",
  contentManagement: "/admin/cms",
  updateContentManagement: "/admin/cms",
  orderList: "/admin/order",
  orderDetails: "/admin/order",
  orderRefund: "/admin/order/orderRefund",
  addPayoutCrDrNote: "/admin/addPayoutCrDrNote",
  listPayoutCrDrNote: "/admin/listPayoutCrDrNote",
  getPayoutCrDrNoteDetail: "/admin/getPayoutCrDrNoteDetail",
  dishReviewList: "/admin/DishReviewList",
  restaurantReviewList: "/admin/restaurantReviewList",
  dishOverAllRating: "/admin/dishOverAllRating",
  restaurantOverAllRating: "/admin/restaurantOverAllRating",
  restaurantReviewOnDetail: "/admin/restaurantReviewOnDetail",
  restaurantOverAllRatingOnDetail : "/admin/restaurantOverAllRatingOnDetail",
  // restaurantReviewOnDetail : "/admin/restaurantReviewOnDetail",
  customerListDropdown: "/admin/customerList",
  restaurantListDropdown: "/admin/RestaurantList",
  addNotification: "/admin/addNotification",
  notificationList: "/admin/notificationList",
  variationList : "/admin/variationList",
  updateVariations : "/admin/updateVariation",
  addVariation : "/admin/addVariation",
  addFeaturedRestaurant : "/admin/addFeaturedRestaurant",
  getGlobalParameters : "/admin/getGlobalParameter",
  getGlobalParameterDriverCharge : "/admin/getGlobalParameterDriverCharge",
  getGlobalParameterOtherDetail : "/admin/getGlobalParameterOtherDetail",
  addGlobalParameter : "/admin/addGlobalParameter",
  updateGlobalParameterCommission : "/admin/updateGlobalParameterCommission",
  addGlobalParameterDriverCharge : "/admin/addGlobalParameterDriverCharge",
  addGlobalParameterOtherDetail : "/admin/addGlobalParameterOtherDetail",
  getDriverList : "/admin/getDriverList",
  getDriverDetail : "/admin/getDriverDetail",
  updateDriverStatus : "/admin/updateDriverStatus",
  addDriver : "/admin/addDriver",
  getDriverOrderDeliveryList: "/admin/getDriverOrderDeliveryList",
  getTransactionList: "/admin/getTransactionList",
  getViewTransaction: "/admin/getViewTransaction",
  restaurantDriverList : "/admin/restaurantDriverList",
  restaurantOrderList: "/admin/restaurentOrders",
  aiPhoneOrders: "/admin/order/aiPhoneOrders",
  restaurantSubscriptionList: "/admin/restaurent/subscription/restaurantSubscriptionList",
  restaurantSubscriptionDetail: "/admin/restaurent/subscription/subscriptionDetail",
  restaurantDelivaryChargList : "/admin/restaurantDelivaryChargList",
  restaurantDelivaryPinCodeList : "/admin/restaurantDelivaryPinCodeList",
  cityList: "/admin/cityList",
  pincodeList: "/admin/pincodeList",
  addPincode: "/admin/addPincode",
  updatePincode: "/admin/updatePincode",
  addLocationPincode: "/admin/addLocationPincode",
  updateLocationPincode: "/admin/updateLocationPincode",
  deleteLocationPincode: "/admin/deleteLocationPincode",
  locationList: "/admin/locationList",
  locationPincodeList: "/admin/locationPincodeList",
  dashboard: "/admin/dashboard",
  listOfPayout: "/admin/listOfPayout",
  listOfPayoutRestaurant: "/admin/listOfPayoutRestaurant",
  listOfPayoutRestaurantOrder: "/admin/listOfPayoutRestaurantOrder",
  listOfPayoutOrderDetailList: "/admin/listOfPayoutOrderDetailList",
  payoutReschedule: "/admin/payoutReschedule",
  viewPayoutOrderDetails: "/admin/viewPayoutOrderDetails",
  getWalletLedger: "/admin/getWalletLedger",
  getRestaurantWalletLedger: "/admin/getRestaurantWalletLedger",
  getDriverWalletLedger: "/admin/getDriverWalletLedger",
  createRestaurantSalesReport: "/admin/createRestaurantSalesReport",
  createRestaurantOrderReport: "/admin/createRestaurantOrderReport",
  getXlsxLog: "/admin/getXlsxLog",
};
export const devAbiConfig = {};
